import { ChangeDetectionStrategy, Component, OnInit, computed, inject, input } from '@angular/core';

import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { DsListItem } from '@frontend/ui/list-item';
import { ProductHomepagesConfig } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import {
    ILinearBetslipMessagesProviderService,
    LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
} from '../../../../../../base/services/betslip-messages-provider.service';

interface IRewardsCtaMessages {
    RewardsCtaTitle: string;
    RewardsCtaBalance: string;
}
@Component({
    selector: 'bs-result-rewards-cta',
    templateUrl: './result-rewards-cta.component.html',
    styleUrls: ['./result-rewards-cta.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconCustomComponent, DsListItem],
})
export class ResultRewardsCtaComponent implements OnInit {
    userPoints = input<number | undefined>();

    private messageProvider: ILinearBetslipMessagesProviderService = inject(LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN);
    private readonly redirectHelper = inject(RedirectHelperService);
    private readonly productHomepagesConfig = inject(ProductHomepagesConfig);
    private readonly loyaltyUrl = '/mobileportal/loyaltystore';
    messages: IRewardsCtaMessages;

    balanceMessage = computed(() => {
        const points = this.userPoints();
        if (points !== undefined) {
            return interpolateDoubleBracesString(this.messages.RewardsCtaBalance, { balance: Math.floor(points) });
        }

        return '';
    });

    ngOnInit(): void {
        const { linear } = this.messageProvider.getMessages();

        this.messages = {
            RewardsCtaTitle: linear.RewardsCtaTitle,
            RewardsCtaBalance: linear.RewardsCtaBalance,
        };
    }

    navigateToLoyalty(): void {
        this.redirectHelper.goToPage(this.productHomepagesConfig.portal + this.loyaltyUrl);
    }
}
